
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs';
import { Authenticate } from '../authenticate/authenticate';
import { Tracking, TrackingCreate } from './tracking';

@Injectable({ providedIn: 'root' })
export class TrackingService {
    
    auth : Authenticate;
    token = environment.token;
    trackingurl = environment.appURL+"/trackings";


    constructor(private http: HttpClient) { }



gettrackings()
{
  return this.http.get<Tracking[]>(this.trackingurl,{headers: new HttpHeaders({"Authorization":"Bearer " + this.token})})
  .pipe(
    tap(_ =>{}),
    catchError(this.handleError('getTicketes', []))
  );

}


 gettrackingById(id: number)
 {
   const url = `${environment.appURL}/trackings/${id}`;
   return this.http.get<Tracking>( url,{headers: new HttpHeaders({"Authorization":"Bearer " + environment.token})})
   .pipe(
     tap(_ => {}),
     catchError(this.handleError<Tracking>(`tracking get id=${id}`))
   );
  
 }


 createTracking(track : TrackingCreate)
 {
    var upd = JSON.stringify(track);

    return this.http.post<Tracking>(`${environment.appURL}/Trackings/`, upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) });
 }
    gettrackingByIdQl(id:number)
 {
        var query =  "{tracking( id: " + id+ "){id name address email machines{id serialnumber modelnumber shortname state{statevalue} location{id addr1 addr2 City Country}} locations{id addr1 addr2}}}";
        //var query =  "{tracking( id: " + id+ "){id name address email machines{id serialnumber modelnumber shortname state{statevalue} location{id addr1 addr2 City Country tracking{id name}}}}}";
     const url = environment.graphURL + query;
   return this.http.get<Tracking>( url,{headers: new HttpHeaders({"Authorization":"Bearer " + environment.token})})
   .pipe(map(data => data['data']['tracking'])
   );
  }
    
  deleteTracking(id : number): Observable<any> {
    const urld = this.trackingurl + "/" + id; 
    return this.http.delete<Tracking>(urld, { headers: new HttpHeaders({ "Authorization": "Bearer " + this.token }) }).pipe(tap(_ => { }), catchError(this.handleError('getDispatchOrders', [])));
      }
    

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }    
}
